import { LayoutGap } from '@gov-nx/ui/web';
import { Skeleton } from '../../Skeleton/Skeleton';

export const RezaEligibleListSkeleton = () => (
	<LayoutGap gap="s">
		<Skeleton
			height="20px"
			width="20%"
		/>
		<div className="[ md:w-[350px] ]">
			<Skeleton
				width="100%"
				height="40px"
			/>
		</div>
	</LayoutGap>
);
